<template>
  <transition name="fade" mode="out-in">
    <loader v-if="loading" />
    <div v-if="!loading">
      <verification-complete v-if="complete" />
      <verification-failed v-if="failed" />
    </div>
  </transition>
</template>

<script>
import Loader from "Components/Loader";
import { verifyEmail } from "Adapters/ApiAdapter/register";
import VerificationComplete from "Public/views/Authorization/EmailVerification/VerificationComplete";
import VerificationFailed from "Public/views/Authorization/EmailVerification/VerificationFailed";
import verifyViewMixin from "Public/views/Authorization/mixins/verifyViewMixin";

export default {
  name: "EmailVerification",
  components: { VerificationFailed, VerificationComplete, Loader },
  mixins: [verifyViewMixin],
  methods: {
    verify() {
      verifyEmail(this.token)
        .then(() => {
          this.complete = true;
        })
        .catch(() => {
          this.failed = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
